<div *ngIf="iconName && visibility" class="button-container">
  <div kendoTooltip tooltipClass="kendo-tooltip">
    <span [title]="title | lowercase">
      <button class="icon-position" mat-icon-button onclick="this.blur()" (click)="onClick()">
        <mat-icon class="material-icons-outlined">visibility</mat-icon>
      </button>
    </span>
  </div>
</div>
